package org.dronda.app.web.ui.login

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.launch
import org.dronda.app.web.service.AuthService

class LoginViewModel(
    private val authService: AuthService,
) {
    private val scope = CoroutineScope(Dispatchers.Default)
    private val eventSink = MutableSharedFlow<Event>(extraBufferCapacity = 8)

    init {
        scope.launch {
            eventSink.collect { event ->
                when (event) {
                    Event.BeginLoginFlow -> authService.initiateAuthFlow()
                }
            }
        }
    }


    fun take(event: Event) {
        eventSink.tryEmit(event)
    }

    sealed interface Event {
        object BeginLoginFlow : Event
    }
}